import React, { FC, useMemo, useState } from 'react';
import { Lights, CanvasBackground, Planet } from '../../../../components';
import { Stats } from '@react-three/drei';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { extend, useThree } from '@react-three/fiber';
import { randPlanet } from '../../../../traits/randPlanet';
import { randTexture } from '../../../../textures';
import { useCamera } from '../../../../utils';

extend({ OrbitControls });

export type PlanetNFTProps = {};
export const PlanetNFT: FC<PlanetNFTProps> = () => {
  useCamera([0, -70, 0], [0, 0, 0], 60);
  const [version, setVersion] = useState(0);
  const { planet, background } = useMemo(
    () => ({
      planet: randPlanet(10, 20, true),
      background: randTexture(),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [version],
  );
  const {
    camera,
    gl: { domElement },
  } = useThree();

  return (
    <group onClick={() => setVersion(version + 1)}>
      <Stats />
      <Lights />
      <CanvasBackground texture={background} />
      <Planet {...planet} position={[0, 0, 0]} />
      {
        //@ts-ignore
        <orbitControls
          args={[camera, domElement]}
          enablePan={false}
          enableZoom={false}
        />
      }
    </group>
  );
};
